import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '@/routes/routes.type';
import { AuthStore } from '@/store/auth.store';

export const guestGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isAuthenticated()) {
    router.navigate(['/', APP_ROUTES.DASHBOARD]).then();
    return false;
  }

  return true;
};
